import { render, staticRenderFns } from "./Formas_CreacionFichero.vue?vue&type=template&id=14ad6cfa&scoped=true"
import script from "./Formas_CreacionFichero.vue?vue&type=script&lang=js"
export * from "./Formas_CreacionFichero.vue?vue&type=script&lang=js"
import style0 from "./Formas_CreacionFichero.vue?vue&type=style&index=0&id=14ad6cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ad6cfa",
  null
  
)

export default component.exports